import { styled, css, withTheme } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Input, Div } from '@vebox/etui-system-elements';
import { fade } from '@vebox/etui-colors';
import '../Label/Label.js';
import ToggleLabel$1 from './ToggleLabel.js';

const ToggleInput = styled(Input)`
  display: none;
`;

const _excluded = ["getStyles"];
const ToggleTrack = styled(Div)`
  ${({
  isLarge,
  theme
}) => css`
    --toggleSize: ${isLarge ? '24px' : '20px'};
    --borderWidth: 2px;
    width: calc(var(--toggleSize) * 2.25);
    height: calc(
      var(--toggleSize) + calc(var(--borderWidth) * ${isLarge ? 2.5 : 2})
    );
    background-color: ${theme.palette.common.white};
    border: var(--borderWidth) solid ${theme.palette.divider};
  `};
  position: relative;
  border-radius: var(--toggleSize);
  transition: all 0.2s;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    right: 50%;
    height: var(--toggleSize);
    width: var(--toggleSize);
    ${({
  theme
}) => css`
      background: ${theme.palette.common.white};
      box-shadow: 0 0 4px 0 ${fade(theme.palette.primary.main, 0.4)};
    `};
    border-radius: 50%;
    transition: right 0.2s;
    transform: translateY(-50%);
  }

  ${({
  isChecked,
  isLarge,
  isDisabled,
  theme
}) => isChecked && css`
      background-color: ${isDisabled ? theme.palette.divider : theme.palette.primary.main};
      border-color: ${isDisabled ? theme.palette.divider : theme.palette.primary.main};
      &::before {
        left: ${isChecked ? 'auto' : '1px'};
        right: ${isChecked ? isLarge ? '1px' : '0px' : 'auto'};
      }
    `};

  ${({
  isDisabled,
  theme
}) => isDisabled && css`
      background-color: ${theme.palette.divider};
    `};

  ${_ref => {
  let {
      getStyles
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return getStyles === null || getStyles === void 0 ? void 0 : getStyles(props);
}}
`;

const ToggleLabel = styled('label')`
  display: flex;
  align-items: center;
  cursor: pointer;

  ${({
  isDisabled
}) => isDisabled && css`
      cursor: not-allowed;
    `};
`;

const Toggle = ({
  onChange,
  name,
  id = name,
  isLarge,
  isDisabled,
  isChecked = false,
  renderLabels,
  theme,
  styles = {},
  labelPlacement = 'right'
}) => {
  function handleChange(event) {
    const {
      checked
    } = event.target;
    if (isDisabled) {
      return;
    }
    if (onChange) {
      onChange(event, checked);
    }
  }
  return /*#__PURE__*/createElement(Div, _extends({
    display: "inline-block",
    testId: "toggle-wrapper"
  }, styles.root), /*#__PURE__*/createElement(ToggleLabel, {
    isDisabled: isDisabled
  }, labelPlacement === 'left' && /*#__PURE__*/createElement(ToggleLabel$1, {
    placement: labelPlacement,
    htmlFor: id || name,
    theme: theme
  }, renderLabels === null || renderLabels === void 0 ? void 0 : renderLabels(isChecked)), /*#__PURE__*/createElement(ToggleInput, {
    id: name || id,
    name: name,
    type: "checkbox",
    checked: isChecked,
    onChange: handleChange,
    disabled: isDisabled
  }), /*#__PURE__*/createElement(ToggleTrack, {
    isChecked: isChecked,
    isDisabled: isDisabled,
    isLarge: isLarge,
    getStyles: styles.track
  }), labelPlacement === 'right' && /*#__PURE__*/createElement(ToggleLabel$1, {
    placement: labelPlacement,
    htmlFor: id || name,
    theme: theme
  }, renderLabels === null || renderLabels === void 0 ? void 0 : renderLabels(isChecked))));
};
var Toggle$1 = withTheme(Toggle);

export default Toggle$1;
